module.exports = __webpack_public_path__ + "img/logo.2b6cc916.png";